<app-time-off-request-modal
    title="Leave of Absence Request"
    [visible]="visible"
    (visibleChange)="visible = $event; visibleChange.emit($event)"
    [isScreenSmall]="!!(screen.xSmallScreenChanged | async)"
    [height]="'auto'"
    [canEdit]="canEdit"
    [canApprove]="canApprove"
    [canDecline]="canDecline"
    [canWithdrawn]="canWithdrawn"
    (save)="onSave()"
    (close)="close()"
    (statusChange)="changeStatus($event)"
    [timeOffRequest]="request"
>
    @if (formData) {
        <dx-form>
            <dxi-item>
                <label class="form-label">Employee*</label>
                <pictured-item-select-box
                    [value]="formData.employee.id"
                    (valueChange)="onEmployeeChange($event)"
                    [dataSource]="employeesDataSource"
                    [readOnly]="!canEditEmployee"
                ></pictured-item-select-box>
            </dxi-item>
            <dxi-item>
                <dx-date-range-box
                    stylingMode="filled"
                    [(startDate)]="formData.requestedStartDate"
                    [(endDate)]="formData.requestedEndDate"
                    (startDateChange)="onStartDateChange($event)"
                    (endDateChange)="onEndDateChange($event)"
                    [readOnly]="!canEdit"
                >
                    <dx-validator>
                        <dxi-validation-rule type="required"></dxi-validation-rule>
                    </dx-validator>
                </dx-date-range-box>
            </dxi-item>
            <dxi-item>
                <strong>Leave of Absence Day(s) Requested:</strong>
                @if (formData.workingDays) {
                    {{ formData.workingDays }}
                } @else {
                    {{ daysRequested | async }}
                }
            </dxi-item>
            <dxi-item>
                <dx-text-area
                    label="Description*"
                    stylingMode="filled"
                    [height]="70"
                    [(value)]="formData.description"
                    [readOnly]="!canEdit"
                >
                    <dx-validator>
                        <dxi-validation-rule type="required"></dxi-validation-rule>
                    </dx-validator>
                </dx-text-area>
            </dxi-item>
            <dxi-item>
                @if (canEdit) {
                    <dx-file-uploader
                        selectButtonText="Upload Files"
                        uploadMode="useForm"
                        [(value)]="files"
                        [disabled]="!canEdit"
                        [multiple]="true"
                    ></dx-file-uploader>
                } @else {
                    @if (formData.files?.length) {
                        @for (file of formData.files; track file.fileUrl) {
                            <div class="mt-3">
                                <a [href]="file.fileUrl" target="_blank">
                                    {{ file.fileName }}
                                </a>
                            </div>
                        }
                    }
                }

            </dxi-item>
        </dx-form>
    }

</app-time-off-request-modal>
